enum StudentRegistrationStatus {
  UNKNOWN = 0,
  UNREGISTERED = 1,
  REGISTERED = 2,
}

export default StudentRegistrationStatus;
